import {useSelector} from 'react-redux'
import styles from './Subscriptions.module.css'
import {selectAllCurrencies} from '../../settings/settingsSlice'
import {getCurrencySymbol} from '../../../util/intl'

const PriceOption = ({price})=>{
	//get all accepted currencies && generate map from lowercase ISO to data
	//lowercase because stripe stores them in lowercase
	const acceptedCurrencies = useSelector(selectAllCurrencies)
	const acceptedCurrencyMap = {}
	acceptedCurrencies.forEach( currency => {
		acceptedCurrencyMap[currency?.ISO.toLowerCase()] = currency
	})
	//use map to get price data for the pricing currency
	const currency = acceptedCurrencyMap[price.currency]

	const intervalString = (
		price.recurring.interval_count > 1 
		? `${price.recurring.interval_count} ${price.recurring.interval}s`
		: price.recurring.interval
	)

	const taxPercent = useSelector(state=>state.settings.app.tax_percent)
	const dollarAmount = price.dollar_amount*(1+taxPercent/100)

	return (
		<div className={styles.Price}>
			{getCurrencySymbol(currency?.ISO)}{dollarAmount.toFixed(2)} ({currency?.ISO}) every {intervalString}
		</div>
	)
}

export default PriceOption